const PIXEL_ID = '2248299922685187';
const PIXEL_ID_SECONDARY = '29025530597083185';
const COOKIE_CONSENT_KEY = 'yoursetl_cookie_consent';

export const hasMarketingConsent = () =>
  typeof window !== 'undefined' &&
  localStorage.getItem(COOKIE_CONSENT_KEY) === 'accepted';

// Creates the fbq queue stub WITHOUT loading any Meta script (no network requests),
// and revokes consent so nothing is sent until the visitor accepts.
export const initMetaConsentStub = () => {
  if (typeof window === 'undefined' || window.fbq) return;

  const n = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  window.fbq = n;
  window._fbq = n;

  window.fbq('consent', 'revoke');
};

export const loadMetaPixel = () => {
  if (typeof window === 'undefined') return;
  initMetaConsentStub();
  if (window.__metaPixelLoaded) return;
  window.__metaPixelLoaded = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  // Consent must be granted directly on the loaded library, not via the queue
  script.onload = () => window.fbq('consent', 'grant');
  document.head.appendChild(script);

  window.fbq('init', PIXEL_ID);
  window.fbq('init', PIXEL_ID_SECONDARY);
  window.fbq('track', 'PageView');
};

export const trackMeta = (eventName, params = {}) => {
  if (typeof window === 'undefined' || !window.fbq) return;
  if (!hasMarketingConsent() || !window.__metaPixelLoaded) return;
  window.fbq('track', eventName, params);
};

export const trackMetaCustom = (eventName, params = {}) => {
  if (typeof window === 'undefined' || !window.fbq) return;
  if (!hasMarketingConsent() || !window.__metaPixelLoaded) return;
  window.fbq('trackCustom', eventName, params);
};
